"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CodeObjectSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9 10h1v1H9v-1Zm-1 0H7v1h1v-1ZM6.326 4A2.326 2.326 0 0 0 4 6.326v.22c0 .626-.155 1.242-.452 1.793A1.26 1.26 0 0 1 2.44 9H2v1h.44c.463 0 .888.254 1.108.661.297.55.452 1.167.452 1.792v.221A2.326 2.326 0 0 0 6.326 15h.245A.429.429 0 0 0 7 14.571V14.4a.4.4 0 0 0-.4-.4h-.136A1.463 1.463 0 0 1 5 12.537a4.39 4.39 0 0 0-.464-1.964L4 9.5l.536-1.073A4.39 4.39 0 0 0 5 6.464C5 5.655 5.655 5 6.464 5H6.6a.4.4 0 0 0 .4-.4v-.171A.429.429 0 0 0 6.571 4h-.245Zm4.348 0A2.326 2.326 0 0 1 13 6.326v.22c0 .626.155 1.242.453 1.793.22.407.644.661 1.107.661H15v1h-.44c-.463 0-.888.254-1.107.661A3.775 3.775 0 0 0 13 12.453v.221A2.326 2.326 0 0 1 10.674 15h-.245a.429.429 0 0 1-.429-.429V14.4c0-.22.18-.4.4-.4h.136c.809 0 1.464-.655 1.464-1.463 0-.682.159-1.354.463-1.964L13 9.5l-.537-1.073A4.39 4.39 0 0 1 12 6.464C12 5.655 11.345 5 10.537 5H10.4a.4.4 0 0 1-.4-.4v-.171c0-.237.192-.429.429-.429h.245Z" })));
};
CodeObjectSmall.displayName = 'CodeObjectSmall';
exports.default = CodeObjectSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CodeObjectSmall.js.map